export const PAGE_MY_PARKING_LOT_PARKING_LOT = 'PAGE_MY_PARKING_LOT_PARKING_LOT'
export const PAGE_MY_PARKING_LOT_PARKING_LOT_MODIFY = 'PAGE_MY_PARKING_LOT_PARKING_LOT_MODIFY'
export const PAGE_MY_PARKING_LOT_PARKING_LOT_BARRIERS = 'PAGE_MY_PARKING_LOT_PARKING_LOT_BARRIERS'
export const PAGE_MY_PARKING_LOT_PARKING_LOT_NOTIFICATIONS = 'PAGE_MY_PARKING_LOT_PARKING_LOT_NOTIFICATIONS'
export const PAGE_MY_PARKING_LOT_PAYMENTS = 'PAGE_MY_PARKING_LOT_PAYMENTS'
export const PAGE_MY_PARKING_LOT_ANALYTICS = 'PAGE_MY_PARKING_LOT_ANALYTICS'
export const PAGE_MY_PARKING_LOT_CUSTOMER_NOTIFICATION_EXCLUSIONS = 'PAGE_MY_PARKING_LOT_CUSTOMER_NOTIFICATION_EXCLUSIONS'

export const PAGE_SUBSCRIPTIONS_BUY = 'PAGE_SUBSCRIPTIONS_BUY'
export const PAGE_SUBSCRIPTIONS_FREE_TIME = 'PAGE_SUBSCRIPTIONS_FREE_TIME'
export const PAGE_SUBSCRIPTIONS_SUBSCRIPTIONS = 'PAGE_SUBSCRIPTIONS_SUBSCRIPTIONS'
export const PAGE_SUBSCRIPTIONS_PERMITS = 'PAGE_SUBSCRIPTIONS_PERMITS'
export const PAGE_SUBSCRIPTIONS_SUBSCRIPTION_OFFERS = 'PAGE_SUBSCRIPTIONS_SUBSCRIPTION_OFFERS'

export const PAGE_RESERVATIONS_MY_RESERVATIONS = 'PAGE_RESERVATIONS_MY_RESERVATIONS'
export const PAGE_RESERVATIONS_RESERVATIONS = 'PAGE_RESERVATIONS_RESERVATIONS'
export const PAGE_RESERVATIONS_RESERVATION_OFFERS = 'PAGE_RESERVATIONS_RESERVATION_OFFERS'
